import {ActionsTypes} from "../consts/actionsTypes";
import {AppDispatch} from "../store";
import {ILoadingComponents} from "../../interfaces/datesGlobalState.interface";
import {OptionalDays} from "../../config/generals";

export const setDatesRange = (startDate: string, endDate: string) => (dispatch: AppDispatch) => {
    dispatch({type: ActionsTypes.SET_TIME_RANGE, payload: {startDate, endDate}})
}

export const setIsLoading = (isLoading: Partial<ILoadingComponents>) => (dispatch: AppDispatch) => {
    dispatch({type: ActionsTypes.SET_IS_LOADING, payload: {isLoading}})
}

export const setComparisonDate = (selectedComparison:OptionalDays) => (dispatch: AppDispatch) => {
    dispatch({type: ActionsTypes.SET_COMPARISON_DATE, payload:+selectedComparison})
}